import { DeleteIcon } from '@/legacy/components/ui/Icons';
import { useNotifications } from '@/legacy/hooks/useNotifications';

import clsx from 'clsx';

type NotificationItemProps = {
	id: number | string;
	imageSrc: string;
	title: string;
	subtitle: string;
	time: string;
	onClick?: () => void;
	className?: string;
	read: boolean;
};

const NotificationItem = ({
	id,
	imageSrc,
	title,
	subtitle,
	time,
	onClick,
	className,
	read,
}: NotificationItemProps) => {
	const { markAsRead, clearOne } = useNotifications();

	const handleClick = () => {
		if (!read) {
			markAsRead(id);
		}
		onClick && onClick();
	};

	const formatTime = (time: string) => {
		if (time.split(':').length === 3) {
			return time.slice(0, 5); // Extract hours and minutes
		}
		return time;
	};

	return (
		<button
			onClick={handleClick}
			className={clsx(
				'flex items-center gap-2 py-4 px-4 rounded-full bg-light border-2 hover:bg-secondary-ultra-light transition-all',
				read ? 'border-tertiary' : 'border-primary',
				'w-full text-left',
				className,
			)}
		>
			<img
				src={imageSrc}
				alt={title}
				className={clsx('w-8 h-8 rounded-full object-cover', read ? 'opacity-50' : 'opacity-100')}
			/>
			<div className='w-full min-w-0'>
				<div className='flex-1 flex justify-between w-full items-baseline'>
					<h4
						className={clsx(
							'truncate',
							read ? 'font-normal text-tertiary' : 'font-semibold text-secondary',
						)}
					>
						{title}
					</h4>
					<div className='flex items-baseline gap-2'>
						<span className={clsx('text-xs text-tertiary ', !read && 'font-semibold mr-2')}>
							{formatTime(time)}
						</span>
						{read && (
							<button
								type='button'
								className='p-0 mr-2 flex items-center justify-center text-error'
								onClick={(event) => {
									event.stopPropagation();
									clearOne(id);
								}}
							>
								<DeleteIcon
									width={12}
									height={12}
								/>
							</button>
						)}
					</div>
				</div>
				<p className={clsx('text-xs truncate', read ? 'text-tertiary' : 'text-secondary')}>
					{subtitle}
				</p>
			</div>
		</button>
	);
};

export default NotificationItem;
